import React, {useEffect, useState} from 'react';
import './style.css'
import {ReactComponent as ArrayIcon} from '../../../../assets/main/course/array.svg';
import Masonry from 'react-masonry-css';
import {NavLink} from "react-router-dom";
import {useAppSelector} from "common/hook";
import {Preloader} from "../../../layout/preloader/Preloader";


interface ICourseContainer {
    valueCourse: string
}

export const CourseContainer = ({valueCourse}: ICourseContainer) => {
    const courses = useAppSelector((state) => state.courses.courseData.courses);
    const currencies = useAppSelector((state) => state.courses.courseData.currencies);
    const isLoading = useAppSelector((state) => state.courses.isLoading);
    const [showFullDescriptions, setShowFullDescriptions] = useState<{ [key: number]: boolean }>({});
    const [rate, setRate] = useState(0);


    useEffect(() => {
        const currencyWithMatchingTitle = currencies?.find(item => item.title === valueCourse);
        if (currencyWithMatchingTitle) {
            setRate(currencyWithMatchingTitle.rate);
        }
    }, [currencies, valueCourse]);


    // Функция для переключения состояния показа полного описания для конкретного курса
    const toggleDescription = (courseId: number) => {
        setShowFullDescriptions((prevState) => ({
            ...prevState,
            [courseId]: !prevState[courseId] || false,
        }));
    };

    return (
        <Masonry
            breakpointCols={{default: 2, 768: 1}}
            className="masonry-grid two-cols-grid"
            columnClassName="masonry-grid_column"
        >
            {isLoading ? (
                <Preloader/>
            ) : (
                courses ? courses.map((course) => (
                    <div className="item card-item sub-color-text" key={course.id}>
                        <p className="h3">
                            <a target='_blank' href={course.url}>
                                {course.title}
                            </a>
                        </p>
                        <div className='body-text-course' dangerouslySetInnerHTML={{
                            __html: showFullDescriptions[course.id]
                                ? course.description
                                : course.description.substring(
                                    0,
                                    course.description.indexOf('<div class="show-content">')
                                ),
                        }}
                        />
                        <br/>
                        <span onClick={() => toggleDescription(course.id)}
                              className={`js-show-description ${showFullDescriptions[course.id] ? 'opened-dropdown' : ''}`}>
                            {showFullDescriptions[course.id] ? 'Свернуть описание' : 'Развернуть описание'}
                            <ArrayIcon
                                style={{transform: showFullDescriptions[course.id] ? 'rotate(180deg)' : 'none'}}/>
                        </span>

                        <div className="buy-course">
                            <span className="price">
                                 <span
                                     className="sum">{((1 - (course.discount / 100)) * course.lessonPrice * rate).toFixed(2)}</span>
                                 <span className="currency">{valueCourse}</span> / урок
                                {course.discount > 0 && (
                                    <div className="price-below">
                                    <span className="sum">
                                        {(course.lessonPrice * rate).toFixed(2)}
                                    </span>
                                        <span className="currency">{valueCourse}</span> / урок
                                    </div>
                                )}
                            </span>
                            <NavLink className="btn" to={`/buy-course/${course.id}`}>
                                <span>Купить курс</span>
                            </NavLink>
                        </div>


                    </div>
                )) : null
            )}
        </Masonry>
    );
};
